import React from "react";
import POLineAuditReport from "../../../common/reports/audit/poLineAuditReport";

const POLineAuditIndex = props => {
  return <POLineAuditReport collabType="Pharma Co" {...props} />;
};

export default POLineAuditIndex;
